<mbs-modal #modal
           [isCustomModal]="true"
           [showFooter]="true"
           [titleTextOverflow]="true"
           [title]="'shared:licenses.priceInformationModal.title' | i18next">
  <div modal-body>
    <mbs-alert [type]="alertType.info"
               [icon]="true"
               class="m-0">
      <div>
        {{ 'shared:licenses.priceInformationModal.firstDescription' | i18next }}
      </div>
      <div class="mt-3" [innerHTML]="'shared:licenses.priceInformationModal.secondDescription' | i18next">
      </div>
    </mbs-alert>

  </div>
  <ng-container modalFooter>
    <mbs-button (click)="modal.close()"
                data-dismiss="modal"
                type="secondary">{{ 'shared:buttons.close' | i18next: {format: 'title'} }}
    </mbs-button>
  </ng-container>
</mbs-modal>
